import { z } from "zod";

import {
  type UserLocation,
  UserLocationSchema,
} from "../location/user_location";

import { BodyType } from "./attributes/UserBodyAttributeSet";
import { Ethnicity } from "./attributes/UserEthnicityAttributeSet";
import { Height } from "./attributes/UserHeightAttributeSet";
import { Interest } from "./attributes/UserInterestAttributeSet";
import { Language } from "./attributes/UserLanguageAttributeSet";
import { RelationshipStatus } from "./attributes/UserRelationshipAttributeSet";
import { RolePosition } from "./attributes/UserRoleAttributeSet";
import { Seeking } from "./attributes/UserSeekingAttributeSet";
import { Weight } from "./attributes/UserWeightAttributeSet";

import { isValidDateString } from "@/utils/datetime";

export type UserProfileAttributes = {
  aboutMe: string | null;
  birthday: string | null;
  ethnicity: Ethnicity | null;
  role: RolePosition | null;
  bodyType: BodyType | null;
  relationship: RelationshipStatus | null;
  seeking: Seeking[];
  languages: Language[];
  interests: Interest[];
  weight: Weight | null;
  height: Height | null;
  residence: UserLocation | null;
};

export const UserProfileAttributesSchema = z.object({
  aboutMe: z.nullable(z.string()),
  birthday: z
    .string()
    .nullable()
    .refine((val) => val === null || isValidDateString(val), {
      message: "Birthday must be a valid date in the format 'yyyy-mm-dd'",
    }),
  ethnicity: z.nullable(z.nativeEnum(Ethnicity)),
  role: z.nullable(z.nativeEnum(RolePosition)),
  bodyType: z.nullable(z.nativeEnum(BodyType)),
  relationship: z.nullable(z.nativeEnum(RelationshipStatus)),
  seeking: z.array(z.nativeEnum(Seeking)),
  languages: z.array(z.nativeEnum(Language)),
  interests: z.array(z.nativeEnum(Interest)),
  weight: z.nullable(z.nativeEnum(Weight)),
  height: z.nullable(z.nativeEnum(Height)),
  residence: UserLocationSchema.nullable(),
});
